import { UseApi } from '../utils/axios-pettitions';

export async function getMisServiciosById(id: number) {
    try {
        const { runApi } = UseApi();
        const reponse = await runApi('servicioPorInstalador', 'GET', { id });
        if (!reponse.Success) {
            return {
                isOk: false,
                message: reponse.Message,
            };
        }
        return {
            isOk: true,
            data: reponse.Data,
        };
    } catch {
        return {
            isOk: false,
            message: 'Error al obtener los servicios',
        };
    }
}

export async function getServiciosFiltrados(filtros: {
  id: number;
  numero_servicio?: string;
  fecha_inicio?: string;
  fecha_fin?: string;
}) {
  try {
    const { runApi } = UseApi();
    const response = await runApi('servicioPorInstalador', 'GET', filtros);
    if (!response.Success) {
      return {
        isOk: false,
        message: response.Message,
      };
    }
    return {
      isOk: true,
      data: response.Data,
    };
  } catch {
    return {
      isOk: false,
      message: 'Error al obtener los servicios con filtros',
    };
  }
}


export async function updateEstadoMisServicios(id: number, estado: any, cantidad: number | null) {
    try {
        const { runApi } = UseApi();
        const response = await runApi('servicioPorInstalador', 'PUT', { id, estado, cantidad });
        if (!response.Success) {
            return {
                isOk: false,
                message: response.Message,
            };
        }
        return {
            isOk: true,
            data: response.Data,
        };
    } catch {
        return {
            isOk: false,
            message: 'Error al actualizar el estado de mis servicios',
        };
    }
}

export async function agregarNovedad(postData: any) {
    try {
        const { runApi } = UseApi();
        const response = await runApi('servicioPorInstalador/Novedad', 'PUT', null, postData );
        if (!response.Success) {
            return {
                isOk: false,
                message: response.Message,
            };
        }
        return {
            isOk: true,
            data: response.Data,
        };
    } catch {
        return {
            isOk: false,
            message: 'Error al actualizar el estado de mis servicios',
        };
    }
}